"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteSdkSetup = exports.authSuiteSdkSetup = void 0;
var expired_token_error_handling_strategy_1 = require("../error-handlers/expired-token-error-handling-strategy");
var access_1 = require("../service/access");
var error_response_1 = require("../service/error-response");
var required_params_validator_1 = require("../service/required-params-validator");
var storage_service_1 = require("../service/storage-service");
var tokens_resolving_strategy_1 = require("../service/storage-service/tokens-resolving-strategy");
var useCheckAccessStatusCustomMethods = function (checkAccessStatusMethod) {
    access_1.checkAccessStatusCustomStrategy.setCustomMethod(checkAccessStatusMethod);
    access_1.checkAccessStatusContext.setStrategy(access_1.checkAccessStatusCustomStrategy);
};
var useCheckAccessStatusDefaultMethods = function () {
    access_1.checkAccessStatusContext.setStrategy(access_1.checkAccessStatusDefaultStrategy);
};
var useApplicationAccessTokenDefaultMethods = function () {
    changeAccessTokenManagementStrategies(tokens_resolving_strategy_1.localStorageTokensResolvingStrategy, expired_token_error_handling_strategy_1.refreshTokenDefaultStrategy);
};
var useApplicationAccessTokenCustomMethods = function (getTokenMethod, refreshTokenMethod) {
    tokens_resolving_strategy_1.getAccessTokenCustomStrategy.setCustomMethod(getTokenMethod);
    expired_token_error_handling_strategy_1.refreshTokenCustomStrategy.setRefreshTokenCustomMethod(refreshTokenMethod);
    changeAccessTokenManagementStrategies(tokens_resolving_strategy_1.getAccessTokenCustomStrategy, expired_token_error_handling_strategy_1.refreshTokenCustomStrategy);
};
var setAuthSuiteRequestData = function (authSuiteRequestData) {
    var isAuthSuiteRequestDataValid = required_params_validator_1.requiredParamsValidator.isValid(authSuiteRequestData);
    if (isAuthSuiteRequestDataValid) {
        storage_service_1.authSuiteDataLocalStorageService.setAuthSuiteRequestData(authSuiteRequestData);
    }
    else {
        throw error_response_1.authSuiteErrorFactory.createError(error_response_1.MethodErrorResponse.MISSING_REQUIRED_PARAMS);
    }
};
var setVirginMediaHbaProxy = function (proxy) {
    storage_service_1.authSuiteDataLocalStorageService.setVirginMediaHbaProxy(proxy);
};
var changeAccessTokenManagementStrategies = function (tokenResolvingStrategy, expiredTokenErrorHandlingStrategy) {
    tokens_resolving_strategy_1.tokensResolvingContext.setStrategy(tokenResolvingStrategy);
    expired_token_error_handling_strategy_1.expiredTokenErrorHandlingContext.setStrategy(expiredTokenErrorHandlingStrategy);
};
exports.authSuiteSdkSetup = {
    setAuthSuiteRequestData: setAuthSuiteRequestData,
    setVirginMediaHbaProxy: setVirginMediaHbaProxy,
    useApplicationAccessTokenCustomMethods: useApplicationAccessTokenCustomMethods,
    useApplicationAccessTokenDefaultMethods: useApplicationAccessTokenDefaultMethods,
    useCheckAccessStatusCustomMethods: useCheckAccessStatusCustomMethods,
    useCheckAccessStatusDefaultMethods: useCheckAccessStatusDefaultMethods,
};
var AuthSuiteSdkSetup = /** @class */ (function () {
    function AuthSuiteSdkSetup() {
        return exports.authSuiteSdkSetup;
    }
    return AuthSuiteSdkSetup;
}());
exports.AuthSuiteSdkSetup = AuthSuiteSdkSetup;
